"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ConfiguratorFabricSelector = void 0;
var _configuratorFabricSelector = _interopRequireDefault(require("./components/configurator-fabric-selector"));
exports.ConfiguratorFabricSelector = _configuratorFabricSelector["default"];